import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import countries from 'i18n-iso-countries';
import LanguageDetector from 'i18next-browser-languagedetector';
import intervalPlural from 'i18next-intervalplural-postprocessor';

const languagesPath = '/node_modules/i18n-iso-countries/langs/';
const languages = import.meta.glob('/node_modules/i18n-iso-countries/langs/*.json');
const loadLanguageFile = async (lang) => {
    try {
        const languageKey = `${languagesPath}${lang}.json`;
        if (languages[languageKey]) {
            const module = await languages[languageKey]();
            return module.default;
        }

        throw new Error(`Language file for '${lang}' not found`);
    } catch (e) {
        if (lang !== 'en') {
            console.warn(`Falling back to 'en' for countries locale (missing ${lang})`);
            return loadLanguageFile('en');
        }

        throw e;
    }
}

i18n.use(intervalPlural)
    .use(LanguageDetector)
    .use({
        type: 'backend',
        async read(language, namespace, callback) {
            let lang = language.split('-')[0];

            try {
                const langFile = await loadLanguageFile(lang);
                countries.registerLocale(langFile);
            } catch (e) {
                console.error(e);
            }

            try {
                const res = await import(`../locales/${language}/${namespace}.json`);
                callback(null, res.default);
            } catch (err) {
                try {
                    const res = await import(`../locales/en-GB/${namespace}.json`);
                    callback(null, res.default);
                } catch (err) {
                    callback(err, null);
                }
            }
        }
    })
    .use(initReactI18next)
    .init({
        load: 'currentOnly',
        fallbackLng: {
            'en-CA': ['en-US', 'en-GB'],
            'gb-GB': ['en-GB'],
            'en-US': ['en-GB'],
            'es-ES': ['en-GB'],
            'fr-CA': ['fr-FR', 'en-GB'],
            'fr-CH': ['fr-FR', 'en-GB'],
            'fr-FR': ['en-GB'],
            'it-IT': ['en-GB'],
            'de-CH': ['de-DE', 'en-GB'],
            'de-DE': ['de-CH', 'en-GB'],
            'nl-BE': ['nl-NL', 'en-GB'],
            'nl-NL': ['en-GB'],
            'ca-ES': ['es-ES', 'en-GB'],
            'br': ['fr-FR', 'en-GB'],
            'eu': ['fr-FR', 'en-GB'],
            'ru_RU': ['en-GB'],
            'pt_PT': ['en-GB'],
            'el_GR': ['en-GB'],
            'tr_TR': ['en-GB'],
            default: ['en-GB']
        },
        ns: 'index',
        defaultNS: 'index',
        interpolation: {
            escapeValue: false,
            prefix: '%',
            suffix: '%'
        },
        react: {
            useSuspense: true,
            transSupportBasicHtmlNodes: true
        },
        debug: import.meta.env.MODE !== 'production'
    });

window.i18n = i18n;
export default i18n;
